import React from "react";
import CONST from "../../config/CONST";

const Loading = () => {

    return (
        <div className={`${CONST.CSS_NAMESPACE}LoadingWrapper`}>
            <div className={`${CONST.CSS_NAMESPACE}Loading`}>
                <div/><div/><div/><div/>
            </div>
        </div>
    )
}


export default Loading;
